import axios from "@/components/api/axios";

async function getCampaignOmikuji(data) {
  const query = data;
  const res = await axios.axiosGet(`/api/campaign/getOmikuji?id=${query}`);
  return res;
}

async function getCampaignOmikujiResult(data) {
  let id = { id: data };
  const res = await axios.axiosPost("/api/campaign/applyOmikuji", id);
  return res;
}

export default {
  getCampaignOmikuji,
  getCampaignOmikujiResult
};



// WEBPACK FOOTER //
// ./src/components/api/campaign/omikujiCampaign.js